import React from "react";
import { UserGroupsCard } from "./UserGroupsCard";
import { UserGroupsUIProvider } from "./UserGroupsUIContext";

export function UserGroupsPage({ history }) {
  const userGroupsUIEvents = {
    openNewUserGroupPage: () => {
      history.push("/kullanici-gruplari/ekle");
    },
    openEditUserGroupPage: (id) => {
      history.push(`/kullanici-gruplari/duzenle/${id}`);
    },
  };
  
  return (
    <UserGroupsUIProvider userGroupsUIEvents={userGroupsUIEvents}>
      <UserGroupsCard />
    </UserGroupsUIProvider>
 );
}